import {
  GET_ALL_ESCALATION_GROUP,
  GET_ONE_ESCALATION_GROUP,
} from "../actions/escalationGroupAction";

const initialState = {
  escalationGroups: [],
};

export function escalationGroupReducers(state = initialState, action) {
  switch (action.type) {
    case GET_ALL_ESCALATION_GROUP:
      return { ...state, escalationGroups: action.payload };

    case GET_ONE_ESCALATION_GROUP:
      return { escalationGroups: action.payload };

    default:
      return { ...state };
  }
}
